import Automation from "common/icons/automation.svg";
import Behaviour from "common/icons/behaviour.svg";
import WebMock from "common/icons/web_mock_wms.png";
import WMSLogo from "common/icons/wms_logo.svg";
import Lottie from "lottie-react-web";
import styled from "styled-components";
import ApplicationLinks from "../ApplicationLinks";
import Features from "../Features";
import InfoComponent from "../InfoComponent";
import ClientsAndPartners from "../ValueMedi/ClientsAndPartners";

const WMSAnimation = require("common/icons/WMS_Animation.json");

const MainContainer = styled.div`
  width: 100%;
  overflow: hidden;
`;

const Separator = styled.div`
  height: 10.06rem;
`;

const AnimationContainer = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  transform: scale(1.7) translateX(150px);
  @media screen and (max-width: 1279px) {
    transform: scale(1.2) translateX(100px);
  }
`;

export const WMSAnimationLottie = (
  <Lottie
    options={{
      animationData: WMSAnimation,
      loop: true,
      autoplay: true
    }}
    style={{
      width: "26.12rem",
      height: "28.875rem"
    }}
  />
);

const INFO_DATA = {
  logo: WMSLogo,
  title: "Optimize Your Warehouse Efficiency with Our Comprehensive WMS",
  description: `Empowering warehouse operations by streamlining the entire workflow—from inbound receipt to outbound dispatch. Our WMS provides end-to-end automation, real-time visibility into order statuses, and seamless coordination of picking, packing, and dispatching processes. Enable smarter decision-making with actionable insights, enhance collaboration between teams, and ensure operational excellence every step of the way.`,
  image: <AnimationContainer>{WMSAnimationLottie}</AnimationContainer>
};

const FEATURES_DATA = {
  title: "Unique Propositions",
  description: "Where Innovation Meets Excellence, Delivering Unmatched Value.",
  features: [
    {
      id: 1,
      title: "Seamless Automation",
      image: Automation
    },
    {
      id: 2,
      title: "Behavioural Insights",
      image: Behaviour
    }
  ]
};

const APP_LINKS = {
  webImage: WebMock
};

const Wms = () => (
  <MainContainer>
    <InfoComponent data={INFO_DATA} />
    <Features data={FEATURES_DATA} />
    <ClientsAndPartners />
    <Separator />
    <ApplicationLinks links={APP_LINKS} isAvailableOnMobile={false} />
  </MainContainer>
);

export default Wms;
